import { AnimatePresence, motion } from 'framer-motion'
import styles from './Configurator.module.css'

interface FramePreviewProps {
  frame: 'black' | 'transparent'
  cover: string
}

const coverImages: Record<string, string> = {
  red: '/brandbook/14_red.svg',
  yellow: '/brandbook/12_yellow.svg',
  green: '/brandbook/13_green.svg',
  blue: '/brandbook/11_blue.svg',
}

const frameImages: Record<string, string> = {
  black: '/brandbook/1-frame_negro.svg',
  transparent: '/brandbook/2-frame_trans.svg',
}

export function FramePreview({ frame, cover }: FramePreviewProps) {
  const image = coverImages[cover] || frameImages[frame]

  return (
    <div className={styles.previewContainer}>
      <AnimatePresence mode="wait">
        <motion.img
          key={`${frame}-${cover}`}
          src={image}
          alt={`Marco ${frame} con cubierta ${cover}`}
          className={styles.previewImage}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.05 }}
          transition={{ duration: 0.3 }}
        />
      </AnimatePresence>
    </div>
  )
}
